import type { PlgField, SignupAnswers } from "plg/types";

const answerText = (answers: SignupAnswers, key: string) => {
  const v = answers[key];
  return typeof v === "string" ? v.trim() : "";
};

/**
 * Fills `{fieldKey|fallback}` with that answer, e.g. "What apps do you use at {companyName|your business}"
 * → "What apps do you use at Acme Dental". An empty answer uses the fallback (or nothing).
 */
export function fillAnswers(text: string, answers: SignupAnswers): string {
  return text.replace(/\{(\w+)(?:\|([^}]*))?\}/g, (_m, key: string, fallback?: string) => answerText(answers, key) || fallback || "");
}

/**
 * The field with its wording for these answers: `labelBy` picks the label from another answer (Size reads
 * "Providers" for Medical and Dental, "Producers" for Insurance, "Team size" otherwise); labels and
 * placeholders may also hold `{fieldKey|fallback}`.
 */
export function fieldForAnswers(field: PlgField, answers: SignupAnswers): PlgField {
  const by = field.labelBy;
  const picked = by ? by.labels[answerText(answers, by.field)] ?? by.otherwise : undefined;
  const label = picked ?? field.label;
  return {
    ...field,
    ...(label !== undefined ? { label: fillAnswers(label, answers) } : {}),
    ...(field.searchPlaceholder ? { searchPlaceholder: fillAnswers(field.searchPlaceholder, answers) } : {}),
  };
}
